'use strict';
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = false;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;



//////////////////
// WEBPACK FOOTER
// ./~/_jszip@2.6.1@jszip/lib/defaults.js
// module id = 99
// module chunks = 0